// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"17":"13a982c2","178":"612e38a5","241":"f0483f27","277":"3eaeb4e9","442":"104d32e6","650":"1252dfb1","778":"17f174b2","839":"8cf5534a","896":"68ec868c"}[chunkId] + ".js";
};